import React from "react"
import { BiUser } from "react-icons/bi"
import { BsBuilding } from "react-icons/bs"
import { HiOutlineClipboardCheck, HiOutlineDocumentText } from "react-icons/hi"
import { MdOutlinePayments } from "react-icons/md"
import { RiAdminLine } from "react-icons/ri"

export type MenuSection = {
  title: string
  icon: React.ReactNode
  items: {
    name: string
    path: string
  }[]
  adminOnly?: boolean
}

export const MENU_SECTIONS: MenuSection[] = [
  {
    title: "CS・ユーザー",
    icon: <BiUser />,
    items: [
      { name: "チャット", path: "/admin/chat" },
      { name: "ユーザー一覧", path: "/admin/users" },
    ],
  },
  {
    title: "審査関連",
    icon: <HiOutlineClipboardCheck />,
    items: [
      { name: "審査一覧", path: "/admin/for-cic" },
      { name: "CIC用CSV", path: "/admin/fetch-cic-csv" },
    ],
  },
  {
    title: "クレジット契約関連",
    icon: <HiOutlineDocumentText />,
    items: [{ name: "クレジット契約準備一覧", path: "/admin/credit-contract-preparation-list" }],
  },
  {
    title: "加盟店（事業者・店舗）",
    icon: <BsBuilding />,
    items: [
      { name: "加盟店申し込み審査", path: "/admin/partner-pre-registrations" },
      { name: "事業者一覧", path: "/admin/companies" },
      { name: "店舗一覧", path: "/admin/stores" },
      { name: "物件登録", path: "/admin/properties/new" },
      { name: "ポップ/チラシ作成", path: "/admin/pdf" },
    ],
  },
  {
    title: "立替・送金",
    icon: <MdOutlinePayments />,
    items: [
      { name: "立替送金申請一覧", path: "/admin/transfer-applications" },
      { name: "送金額計算書", path: "/admin/calculator" },
    ],
  },
  {
    title: "システム管理",
    icon: <RiAdminLine />,
    items: [{ name: "Smoother管理", path: "/admin/smoothers" }],
    adminOnly: true,
  },
]
